/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import Promise from 'bluebird';
import _ from 'underscore';

import { ActionHistory } from '@trello/action-history';
import type { SourceType } from '@trello/atlassian-analytics';
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';
import { isDesktop } from '@trello/browser';
import { ApiError } from '@trello/error-handling';
import { sendErrorEvent } from '@trello/error-reporting';
import { localizeServerError } from '@trello/i18n';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { getKey, Key } from '@trello/keybindings';
import { dangerouslyConvertPrivacyString } from '@trello/privacy';
import ReactDOM from '@trello/react-dom-wrapper';

import { Auth } from 'app/scripts/db/Auth';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { ModelCache } from 'app/scripts/db/ModelCache';
import { l } from 'app/scripts/lib/localize';
import { Util } from 'app/scripts/lib/util';
import { searchFilter } from 'app/scripts/lib/util/text/search-filter';
import { containsValidUrl } from 'app/scripts/lib/util/url/contains-valid-url';
import { Card } from 'app/scripts/models/Card';
import type { Member } from 'app/scripts/models/Member';
import { maybeDisplayMemberLimitsError } from 'app/scripts/views/board-menu/MemberLimitsError';
import { View } from 'app/scripts/views/internal/View';
import { Alerts } from 'app/scripts/views/lib/Alerts';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { SelectMemberOnCardView } from 'app/scripts/views/member/SelectMemberOnCardView';
import { InviteAddNameTemplate } from 'app/scripts/views/templates/InviteAddNameTemplate';
import { PopoverSelectMembersTemplate } from 'app/scripts/views/templates/PopoverSelectMembersTemplate';
import { MultiBoardGuestAlert } from 'app/src/components/MultiBoardGuestAlert';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

const MAX_EXPANDED_MEMBERS = 9;
const MAX_SUGGESTIONS = 5;

interface CardMemberSelectView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _onBoardMembers: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _onCardMembers: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _onListMembers: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _renderMemsPromise: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  orgMembersPromise: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reactRoot: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderMemsDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderSuggestedDebounced: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showAllOrgMembers: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  wouldBecomeBillableGuestPromise: any;
}

function toTitleCase(str: string) {
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
  );
}

function validName(name: string) {
  return name.length >= 1;
}

function removeDomainFromEmailAddress(email: string, additionalChars?: string) {
  if (additionalChars == null) {
    additionalChars = '';
  }
  return email.replace(
    new RegExp(`\
@\
[-a-z0-9\\.${additionalChars}]+\
\\.\
[a-z${additionalChars}]+\
$\
`),
    '',
  );
}

class CardMemberSelectView extends View<
  Card,
  {
    source: SourceType;
  }
> {
  static initClass() {
    this.prototype.viewTitleKey = 'members';
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(options: any) {
    super(options);
    this.wouldBecomeBillableGuest = this.wouldBecomeBillableGuest.bind(this);
  }

  events() {
    return {
      'click .js-board-members .js-select-member': 'selectMem',
      'click .js-org-members .js-select-member': 'selectMem',
      'click .js-suggestions .js-select-member': 'addSuggestedMember',
      'click .js-show-org-members': 'showOrgMembers',
      'mouseenter .pop-over-member-list .item': 'hoverMemberSelect',
      'input .js-search-mem': () => {
        this.updateSearch();
        return this.renderSuggested();
      },

      keydown: 'keydownEvent',

      // send email invite to new email address
      'click .js-send-email-invite': 'sendEmailInvite',
      'submit .js-email-data': 'sendEmailInvite',
    };
  }

  initialize() {
    this.showAllOrgMembers = false;
    this.wouldBecomeBillableGuestPromise = null;

    this.updateSearch = _.debounce(this.updateSearch, 100);

    this.makeDebouncedMethods('renderMems', 'renderSuggested');

    // Return early on the off chance the model is not defined. It really
    // shouldn't be, but Sentry errors are indicating that in some cases it is.
    if (!this.model) {
      return;
    }

    // If the @model is a Card Composer, there won't be a memberList
    // we have to watch
    if (this.model.memberList) {
      this.listenTo(this.model.memberList, 'add remove reset', () => {
        this.updateOrdering();
        this.renderMemsDebounced();
        return this.renderSuggestedDebounced();
      });
    }

    Analytics.sendScreenEvent({
      name: 'cardMemberSelectInlineDialog',
      containers: this.model.getBoard().getAnalyticsContainers(),
      attributes: {
        cardIsTemplate: this.model.get('isTemplate'),
        cardIsClosed: this.model.get('closed'),
      },
    });

    this.updateOrdering();
  }

  remove() {
    if (this.reactRoot) {
      ReactDOM.unmountComponentAtNode(this.reactRoot);
    }
    return super.remove(...arguments);
  }

  updateOrdering() {
    this._onCardMembers = {};
    this._onListMembers = {};
    this._onBoardMembers = {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const addCardMembers = (target: any, card: Card) =>
      card.memberList.forEach((member) => (target[member.id] = true));
    // Might be the card composer
    if (this.model instanceof Card) {
      addCardMembers(this._onCardMembers, this.model);
    }
    this.model
      .getList()
      .cardList.forEach(addCardMembers.bind(null, this._onListMembers));
    return this.model.getBoard().listList.forEach((list) => {
      return list.cardList.forEach(
        addCardMembers.bind(null, this._onBoardMembers),
      );
    });
  }

  render() {
    const board = this.model?.getBoard();

    if (!board) {
      return this;
    }

    this.$el.html(
      PopoverSelectMembersTemplate({
        canInviteMembers:
          !board.hasInvitationRestrictions() && board.canInviteMembers(),
        includeOrgMembers:
          (board.getOrganization() != null && board.canInviteMembers()) ||
          this.model.getBoard().isEditableByTeamMemberAndIsNotABoardMember(),
        placeholder: l('add member placeholder'),
      }),
    );

    this.renderMems();
    return this.renderSuggested();
  }

  getSearch() {
    const searchValue = $('.js-search-mem', this.$el).val() ?? '';
    return searchValue.toString().trim();
  }

  filteredMembers(members: Member[], search: string) {
    const satisfiesSearch = searchFilter(search);

    return _.chain(members)
      .filter((mem) => {
        return satisfiesSearch(Util.getMemNameArray(mem));
      })
      .first(8)
      .value();
  }

  filteredBoardMembers(term: string) {
    const activeMembers = this.activeBoardMembers();

    const sortedMembers = activeMembers.sortBy((member) => {
      const prefix = Auth.isMe(member)
        ? 0
        : this._onCardMembers[member.id]
        ? 1
        : this._onListMembers[member.id]
        ? 2
        : this._onBoardMembers[member.id]
        ? 3
        : 4;

      return prefix + dangerouslyConvertPrivacyString(member.get('fullName'));
    });

    if (term) {
      return this.filteredMembers(sortedMembers, term);
    } else {
      return sortedMembers;
    }
  }

  filteredOrgMembers(term: string) {
    if (this.showOrgSection()) {
      const org = this.model.getBoard().getOrganization();
      if (org?.isPremiumPO()) {
        if (this.orgMembersPromise == null) {
          this.orgMembersPromise =
            ModelLoader.loadOrganizationMembersDataWithAvailableLicenseCount(
              org.id,
            );
        }
      } else {
        if (this.orgMembersPromise == null) {
          this.orgMembersPromise = ModelLoader.loadOrganizationMembersData(
            // @ts-expect-error
            org.id,
          );
        }
      }

      return this.orgMembersPromise.then(() => {
        // @ts-expect-error
        const nonBoardMembers = org.memberList
          .filterDeactivated({ force: true })
          .without(
            ...Array.from(this.model.getBoard().memberList.models || []),
          );

        if (term) {
          return this.filteredMembers(nonBoardMembers, term);
        } else {
          return nonBoardMembers;
        }
      });
    } else {
      return [];
    }
  }

  hasSearch() {
    return this.getSearch() !== '';
  }

  showOrgSection() {
    // Only include team members if they've started searching or clicked on the
    // "Show team members" button … we want to keep the UI simple for the
    // common case
    const org = this.model.getBoard().getOrganization();
    return org != null && (this.showAllOrgMembers || this.hasSearch());
  }

  renderMems() {
    const term = this.getSearch();
    const boardMemList = this.filteredBoardMembers(term);
    const orgMemList = this.filteredOrgMembers(term);

    const sections = {
      '.js-board-members': boardMemList,
      '.js-org-members': orgMemList,
    };

    const showOrgSection = this.showOrgSection();
    $('.js-show-org-members', this.$el).toggleClass('hide', showOrgSection);
    $('.js-invite-results', this.$el).toggleClass(
      'hide',
      !Util.checkEmail(term),
    );

    if (this._renderMemsPromise != null) {
      this._renderMemsPromise.cancel();
    }
    this._renderMemsPromise = Promise.each(_.keys(sections), (selector) => {
      const $section = $(selector, this.$el);
      if ($section.length === 0) {
        return;
      }

      const $loading = $section.find('.js-loading');

      const $noResults = $section.find('.js-no-results');

      $loading.removeClass('hide');
      $noResults.addClass('hide');

      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      return Promise.resolve(sections[selector]).then((memList) => {
        $loading.addClass('hide');

        const $memList = $section.find('.js-mem-list');
        $memList.toggleClass(
          'collapsed',
          memList.length > MAX_EXPANDED_MEMBERS,
        );
        $noResults.toggleClass('hide', memList.length > 0);

        if (memList.length > 0) {
          $('.js-board-members', this.$el).removeClass('hide');
          $('.js-invite-no-results', this.$el).addClass('hide');
          $('.js-org-members', this.$el).toggleClass('hide', !showOrgSection);
        }

        const subviews = Array.from(memList).map((mem) =>
          this.subview(SelectMemberOnCardView, mem, {
            showUnconfirmed: true,
            card: this.model,
          }),
        );

        return this.ensureSubviews(subviews, $memList);
      });
    })
      // @ts-expect-error TS(2339): Property 'cancellable' does not exist on type 'Blu... Remove this comment to see the full error message
      .cancellable()
      .then(() => {
        if (this.hasSearch()) {
          const $elem = this.$el.find('.item').first();
          if ($elem.length > 0) {
            return Util.selectMenuItem(this.$el, '.item', $elem);
          } else {
            return this.renderEmailInviteToSearchResults({ email: term });
          }
        }
      })
      .done();
    return this;
  }

  activeBoardMembers() {
    return this.model.getBoard().memberList.filterDeactivated({ force: true });
  }

  renderSuggested() {
    const $suggestions = $('.js-suggestions', this.$el);

    const suggestedMembers = this.getSuggestedMembers();

    const showSuggestions =
      !this.hasSearch() &&
      suggestedMembers.length > 0 &&
      // Don't bother showing suggestions if we can already see
      // all of the members and their full names
      this.activeBoardMembers().length > MAX_EXPANDED_MEMBERS;

    $suggestions.toggleClass('hide', !showSuggestions);

    const $memberList = $suggestions.find('.js-mem-list');

    if (showSuggestions) {
      const subviews = suggestedMembers.map((member) => {
        return this.subview(
          SelectMemberOnCardView,
          member,
          { card: this.model },
          // @ts-expect-error
          `join-suggestion-${member.id}`,
        );
      });

      this.ensureSubviews(subviews, $memberList);
      Analytics.sendViewedComponentEvent({
        componentType: 'section',
        componentName: 'suggestedMembersSection',
        source: 'cardMemberSelectInlineDialog',
        attributes: {
          totalSuggestedMembers: suggestedMembers.length,
        },
        containers: {
          card: { id: this.model.id },
          board: { id: this.model.get('idBoard') },
          list: { id: this.model.get('idList') },
          organization: { id: this.model.getBoard()?.get('idOrganization') },
        },
      });
    } else {
      $memberList.empty();
    }

    return this;
  }

  getSuggestedMembers() {
    const history = ActionHistory.get();

    const idList = this.model.get('idList');

    const suggested = new Set();

    const joinEntry = { action: { type: 'join', idMember: Auth.myId() } };
    const addMemberEntries = history
      .filter(
        ({ action, context }) =>
          action.type === 'add-member' && context.idList === idList,
      )
      .filter(function ({ action }) {
        // @ts-expect-error TS(2339): Property 'idMember' does not exist on type 'Histor... Remove this comment to see the full error message
        if (suggested.has(action.idMember)) {
          return false;
        } else {
          // @ts-expect-error TS(2339): Property 'idMember' does not exist on type 'Histor... Remove this comment to see the full error message
          suggested.add(action.idMember);
          return true;
        }
      });

    return [joinEntry, ...Array.from(addMemberEntries)]
      .filter(({ action }) => this.model.isValidSuggestion(action))
      .map(({ action }) => {
        // @ts-expect-error TS(2339): Property 'idMember' does not exist on type '{ type... Remove this comment to see the full error message
        return ModelCache.get('Member', action.idMember);
      })
      .slice(0, MAX_SUGGESTIONS)
      .sort(function (a, b) {
        if (Auth.isMe(a)) {
          return -1;
        } else if (Auth.isMe(b)) {
          return 1;
        } else {
          // @ts-expect-error
          const aFullName = a.get('fullName').toLowerCase();
          // @ts-expect-error
          const bFullName = b.get('fullName').toLowerCase();
          return aFullName.localeCompare(bFullName);
        }
      });
  }

  hoverMemberSelect(e: Event) {
    // @ts-expect-error
    return Util.selectMenuItem(this.$el, '.item', e.currentTarget);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  keydownEvent(e: any) {
    const key = getKey(e);

    if ([Key.Tab, Key.Enter].includes(key)) {
      stopPropagationAndPreventDefault(e);
      $('.js-mem-list .item.selected:first .js-select-member', this.$el)
        .first()
        .click();
      $('.js-search-mem', this.$el).val('');
      this.focusSearch();
      this.renderMems();
    } else if ([Key.ArrowUp, Key.ArrowDown].includes(key)) {
      stopPropagationAndPreventDefault(e);
      Util.navMenuList(this.$el, '.item', key);
    }
  }

  updateSearch() {
    $('.js-invite-error', this.$el).addClass('hide');
    this.renderMems();
    return this.focusSearch();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectMem(e: any) {
    stopPropagationAndPreventDefault(e);
    const { model } = this;

    const $mem = $(e.currentTarget);

    const $item = $mem.closest('.item');
    const idMem = $mem.attr('idMember');
    const source = this.options.source || 'cardMemberSelectInlineDialog';

    if ($item.hasClass('active')) {
      const traceId =
        // Do not trace CardComposer member toggling
        model.typeName === 'Card'
          ? Analytics.startTask({
              taskName: 'edit-card/idMembers',
              source,
            })
          : '';

      model.removeMemberWithTracing(
        // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
        idMem,
        traceId,
        tracingCallback(
          {
            taskName: 'edit-card/idMembers',
            traceId,
            source,
          },
          (_err, res) => {
            if (res) {
              Analytics.sendUpdatedCardFieldEvent({
                field: 'idMembers',
                source,
                containers: {
                  card: { id: model.id },
                  board: { id: model.get('idBoard') },
                  list: { id: model.get('idList') },
                  organization: { id: model.getBoard()?.get('idOrganization') },
                },
                attributes: {
                  taskId: traceId,
                  changeType: 'remove member',
                },
              });
            }
          },
        ),
      );

      $item.removeClass('active');
    } else {
      const board = this.model.getBoard();
      const member = ModelCache.get('Member', idMem);

      if (!board.hasActiveMembership(member)) {
        if (
          Auth.isMe(member) &&
          model.getBoard().isEditableByTeamMemberAndIsNotABoardMember()
        ) {
          Alerts.show(
            'woohoo-you-are-now-a-member-of-this-board',
            'info',
            'join-board',
            4000,
          );

          board.optimisticJoinBoard();
        }
      }

      const traceId =
        // Do not trace CardComposer member toggling
        model.typeName === 'Card'
          ? Analytics.startTask({
              taskName: 'edit-card/idMembers',
              source,
            })
          : '';

      model.addMemberWithTracing(
        // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
        idMem,
        traceId,
        tracingCallback(
          {
            taskName: 'edit-card/idMembers',
            traceId,
            source,
          },
          (_err, res) => {
            if (res) {
              Analytics.sendUpdatedCardFieldEvent({
                field: 'idMembers',
                source,
                containers: {
                  card: { id: model.id },
                  board: { id: model.get('idBoard') },
                  list: { id: model.get('idList') },
                  organization: { id: model.getBoard()?.get('idOrganization') },
                },
                attributes: {
                  taskId: traceId,
                  changeType: 'add member',
                },
              });
            }
          },
        ),
      );

      $item.addClass('active');

      // Tracking for adding invitees to cards
      const boardMembers = this.model.getBoard().memberList.models;
      const myId = Auth.me().id;
      return boardMembers.forEach(function (boardMember) {
        if (
          boardMember.get('id') === idMem &&
          boardMember.get('idMemberReferrer') === myId
        ) {
          return Analytics.sendTrackEvent({
            action: 'added',
            actionSubject: 'invitee',
            source,
            attributes: {
              member: myId,
              addedMember: idMem,
            },
            containers: {
              card: { id: model.id },
              board: { id: model.get('idBoard') },
              list: { id: model.get('idList') },
              organization: { id: model.getBoard()?.get('idOrganization') },
            },
          });
        }
      });
    }

    this.focusSearch();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addSuggestedMember(e: any) {
    stopPropagationAndPreventDefault(e);

    const idMember = $(e.currentTarget, this.$el).attr('idMember');
    const source = 'cardMemberSelectInlineDialog';

    const traceId = Analytics.startTask({
      taskName: 'edit-card/idMembers',
      source,
    });

    this.model.addMemberWithTracing(
      // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      idMember,
      traceId,
      tracingCallback(
        {
          taskName: 'edit-card/idMembers',
          traceId,
          source,
        },
        (_err, res) => {
          if (res) {
            Analytics.sendUpdatedCardFieldEvent({
              field: 'idMembers',
              source,
              containers: {
                card: { id: this.model.id },
                board: { id: this.model.get('idBoard') },
                list: { id: this.model.get('idList') },
                organization: {
                  id: this.model.getBoard()?.get('idOrganization'),
                },
              },
              attributes: {
                taskId: traceId,
                changeType: Auth.isMe(idMember) ? 'join' : 'add member',
              },
            });
          }
        },
      ),
    );

    this.focusSearch();
  }

  focusSearch() {
    $('.js-search-mem', this.$el).focus();
  }

  showOrgMembers() {
    this.showAllOrgMembers = true;
    this.renderMems();
  }

  wouldBecomeBillableGuest(email: string) {
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const { ApiPromise } = require('app/scripts/network/ApiPromise');
    const board = this.model.getBoard();

    if (!board.hasOrganization()) {
      return Promise.resolve(false);
    }

    const org = board.getOrganization();
    if (org && !org.isFeatureEnabled('multiBoardGuests')) {
      return Promise.resolve(false);
    }

    return ApiPromise({
      url: '/1/search/members/',
      type: 'get',
      data: {
        idBoard: board != null ? board.id : undefined,
        query: email,
      },
      dataType: 'json',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }).then((data: any) => {
      return data.length === 1 && data[0].wouldBecomeBillableGuest;
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderEmailInviteToSearchResults(data: any) {
    $('.js-invite-no-results', this.$el).removeClass('hide');
    const puncSpacePattern = /[\s\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]+/;
    const puncPattern = /[\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]+/;

    const fullName = _.compact(
      removeDomainFromEmailAddress(data.email).split(puncSpacePattern),
    )
      .join(' ')
      .replace(puncPattern, '');
    const board = this.model.getBoard();
    const org = board != null ? board.getOrganization() : undefined;

    Object.assign(data, {
      fullName: toTitleCase(fullName),
      canAddAsObserver:
        org != null ? org.isFeatureEnabled('observers') : undefined,
      modelType: 'Board',
      isLoading: true,
      isOrgAdmin: org != null ? org.owned() : undefined,
      isDesktop: isDesktop(),
    });

    const isEmailSearch = Util.checkEmail(data.email);
    const canInvite =
      !(board != null ? board.hasInvitationRestrictions() : undefined) &&
      isEmailSearch &&
      (board != null ? board.canInviteMembers() : undefined);

    const workspaceAdmins =
      org?.adminList?.map(
        (member: Member) => member.get('fullName') || member.get('username'),
      ) ?? [];

    $('.js-board-members', this.$el).addClass('hide');
    $('.js-org-members', this.$el).addClass('hide');

    if (canInvite) {
      $('.js-invite-no-results', this.$el).addClass('hide');
      $('.js-invite-results', this.$el)
        .html(InviteAddNameTemplate(data))
        .removeClass('hide');

      if (this.wouldBecomeBillableGuestPromise != null) {
        this.wouldBecomeBillableGuestPromise.cancel();
      }
      return (this.wouldBecomeBillableGuestPromise =
        this.wouldBecomeBillableGuest(data.email)
          .cancellable()
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .then((wouldBecomeBillableGuest: any) => {
            // Update the email form template to remove the loading state and prepare
            // the MBG alert if necessary
            Object.assign(data, {
              isLoading: false,
              wouldBecomeBillableGuest,
              availableLicenseCount:
                org != null ? org.getAvailableLicenseCount() : Infinity,
            });
            $('.js-invite-results', this.$el).html(InviteAddNameTemplate(data));

            // Inject the mbg alert if necessary (lets the user know about any extra billing, or why
            // they are not allowed to invite)
            if (wouldBecomeBillableGuest) {
              const Element = (
                <MultiBoardGuestAlert
                  displayOrg={{
                    id: org?.id,
                    url: org?.get('url'),
                    availableLicenseCount: org?.getAvailableLicenseCount(),
                  }}
                  isWorkspaceAdmin={org?.owned() ?? false}
                  workspaceAdmins={workspaceAdmins}
                />
              );
              if (
                (this.reactRoot = this.el.querySelector(
                  '.js-billable-guests-alert',
                ))
              ) {
                return ReactDOM.render(Element, this.reactRoot);
              }
            }
          })
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .catch(ApiError, (restOrApiError: any) => {
            const error = localizeServerError(restOrApiError);
            Object.assign(data, {
              isLoading: false,
              error,
            });
            return $('.js-invite-results', this.$el).html(
              InviteAddNameTemplate(data),
            );
          })
          .catch(Promise.CancellationError));
    }
  }

  _getNewMemberId(
    updatedMemberIds: string[],
    existingMemberIds: string[],
    newMemberRole: string,
    existingWorkspaceMembers: string[],
    email: string,
  ) {
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const { ApiPromise } = require('app/scripts/network/ApiPromise');
    const newMemberId = _.first(
      _.difference(updatedMemberIds, existingMemberIds),
    );

    if (newMemberId != null) {
      const isNewWorkspaceGuest =
        !existingWorkspaceMembers?.includes(newMemberId) ?? true;

      Analytics.sendTrackEvent({
        action: 'sent',
        actionSubject: 'emailBoardInvitation',
        source: 'cardMemberSelectInlineDialog',
        containers: {
          card: { id: this.model.id },
          board: { id: this.model.get('idBoard') },
          list: { id: this.model.get('idList') },
          organization: { id: this.model.getBoard()?.get('idOrganization') },
        },
        attributes: {
          newMemberRole,
          isNewWorkspaceGuest,
        },
      });
      return Promise.resolve(newMemberId);
    }

    // Someone with this email already belonged to the board, so they couldn't
    // be invited or added. Use server search to find who it is and add them to
    // the card.
    const requestData = {
      query: email,
      ...this.model.getBoard().getInviteURLParams(),
    };

    const searchParams = {
      url: '/1/search/members/',
      type: 'get',
      data: requestData,
      dataType: 'json',
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return ApiPromise(searchParams).then((results: any) => {
      if (results.length > 0) {
        // server-side search by email does an exact search, so this should
        // always return only one result
        return results[0].id;
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sendEmailInvite(e: any) {
    // Dependency required at call site to avoid import cycles, do not lift to top of module
    const { ApiPromise } = require('app/scripts/network/ApiPromise');
    stopPropagationAndPreventDefault(e);

    const $sendButton = $('.js-send-email-invite', this.$el);
    // The email is already being sent
    if ($sendButton.attr('disabled') != null) {
      return;
    }

    const $name = $('.js-email-data .js-full-name', this.$el);
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    const name = $name.val().trim();

    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    const email = $('.js-email-data .js-email', this.$el).val().trim();

    if (!validName(name)) {
      Util.setCaretAtEnd($name);
      $('.js-name-error').show();
      return;
    } else if (containsValidUrl(name)) {
      // Urls are not allowed as member names
      Util.setCaretAtEnd($name);
      $('.js-name-error-url').show();
      return;
    }

    const data = {
      fullName: name,
      email,
      type: 'normal',
      allowBillableGuest: true,
    };

    if ($('#addAsObserver', this.$el).is(':checked')) {
      data.type = 'observer';
    }

    const board = this.model.getBoard();

    if (maybeDisplayMemberLimitsError($(e.target), board)) {
      return;
    }

    // Disable the button while we're sending the invite
    $sendButton.attr('disabled', 'disabled');

    const existingMembers = _.pluck(board.memberList.models, 'id');
    const workspace = board?.getOrganization();

    const existingWorkspaceMembers =
      workspace?.memberList.map(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (member: any) => member.id,
      ) ?? [];

    ApiPromise({
      url: `/1/board/${board.id}/members`,
      type: 'put',
      data,
    })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then(({ members }: any) => {
        const updatedMemberIds = _.pluck(members, 'id');
        return this._getNewMemberId(
          updatedMemberIds,
          existingMembers,
          data.type,
          existingWorkspaceMembers,
          email,
        );
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((newMemberId: any) => {
        if (newMemberId != null) {
          const source = 'cardMemberSelectInlineDialog';
          const traceId = Analytics.startTask({
            taskName: 'edit-card/idMembers',
            source,
          });

          this.model.addMemberWithTracing(
            newMemberId,
            traceId,
            tracingCallback(
              {
                taskName: 'edit-card/idMembers',
                traceId,
                source,
              },
              (_err, res) => {
                if (res) {
                  Analytics.sendUpdatedCardFieldEvent({
                    field: 'idMembers',
                    source,
                    containers: {
                      card: { id: this.model.id },
                      board: { id: this.model.get('idBoard') },
                      list: { id: this.model.get('idList') },
                      organization: {
                        id: this.model.getBoard()?.get('idOrganization'),
                      },
                    },
                    attributes: {
                      taskId: traceId,
                      changeType: 'add member',
                    },
                  });

                  $('.js-send-email-invite', this.$el).prop('disabled', false);
                  return PopOver.hide();
                }
              },
            ),
          );

          return this;
        }
      })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .catch(ApiError, (resOrApiError: any) => {
        const message = localizeServerError(resOrApiError);

        $('.js-invite-error', this.$el)
          .removeClass('hide')
          .find('.error')
          .html(message);
        $('.js-uninvited-search-results', this.$el).empty().hide();

        $sendButton.prop('disabled', false);
        $('js-search-mem').focus().select();

        sendErrorEvent(resOrApiError);
      });
  }
}

CardMemberSelectView.initClass();
export { CardMemberSelectView };
